import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21326044"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "d-flex justify-content-between align-content-end align-items-center text-body my-menu-group"
};
const _hoisted_2 = {
  class: "my-menu-group w-100"
};
const _hoisted_3 = {
  key: 0,
  class: "bx bxs-diamond fs-14 text-end ms-5 gradient-text"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "d-flex justify-content-between align-content-end align-items-center w-100"
};
const _hoisted_6 = {
  key: 0,
  class: "bx bxs-diamond fs-14 text-end gradient-text"
};
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import usePlanPrice from '@/composable/plan-price';
import { menuList } from '@/shared/constants/menu';
import { useRoute, useRouter } from 'vue-router';
import useLayouts from '@/composable/layout';
export default {
  __name: 'menu',
  setup(__props) {
    const {
      isCollapse,
      toggleSidebar
    } = useLayouts();
    const router = useRouter();
    const route = useRoute();
    const {
      currentPlan,
      setPlanPriceDialog
    } = usePlanPrice();
    const store = useStore();
    const userRole = computed(() => permission => {
      return store.getters['auth/hasPermission'](permission);
    });
    const ref1 = ref();
    const canSeeFeatures = computed(() => {
      return code => {
        if (!currentPlan?.value?.features) return false;
        return !!currentPlan?.value?.features?.some(item => item.code === code);
      };
    });
    function handleClickProFeature(path, code = '') {
      if (!code) router.push(path);else {
        let isAbleToSeeFeature = !!currentPlan?.value?.features?.some(item => item.code === code);
        if (!isAbleToSeeFeature) setPlanPriceDialog(!isAbleToSeeFeature);else router.push(path);
      }
    }

    // Recursive filter function
    function filterMenu(menu) {
      return menu.map(item => {
        if (item.children) {
          // Check if children are valid
          const filteredChildren = filterMenu(item.children);

          // Include the item if it has valid children or if it has permission
          if (filteredChildren.length || userRole.value(item.permissionCode)) {
            return {
              ...item,
              children: filteredChildren
            };
          }
        } else if (item.groupTitle) {
          // Handle grouped items
          const filteredItems = item.items.filter(child => {
            if (!child.permissionCode) return true;
            return userRole.value(child.permissionCode);
          });
          if (filteredItems.length) {
            return {
              ...item,
              items: filteredItems
            };
          }
        } else if (userRole.value(item.permissionCode) || !item.permissionCode) {
          return item;
        }
        return null; // Exclude items that don't match the criteria
      }).filter(item => item !== null);
    }

    // Computed property to filter menu items
    const filteredMenuList = computed(() => filterMenu(menuList));
    const flattenMenu = (menuItems = []) => {
      const flattened = [];
      const traverse = items => {
        items.forEach(item => {
          if (!item) return;
          if (item.children && item.children.length) {
            traverse(item.children);
          }
          if (item.groupTitle && Array.isArray(item.items)) {
            traverse(item.items);
          }
          if (item.path && item.index) {
            flattened.push({
              index: item.index,
              path: item.path
            });
          }
        });
      };
      traverse(menuItems);
      return flattened;
    };
    const activeIndex = computed(() => {
      const flattened = flattenMenu(filteredMenuList.value);
      const currentPath = route.path;
      const match = flattened.find(item => currentPath.startsWith(item.path));
      return match?.index ?? '';
    });
    // Function to detect screen size
    const updateCollapseState = () => {
      isCollapse.value = window.innerWidth < 768; // Collapse on small screens (<768px)
    };

    // Add resize event listener
    onMounted(() => {
      updateCollapseState();
      window.addEventListener('resize', updateCollapseState);
      let hasCollapseSaved = localStorage.getItem('isCollapse') === '1';
      if (hasCollapseSaved) {
        toggleSidebar(!!isCollapse);
      }
      // localStorage.getItem('tourTime') ? (open.value = false) : (open.value = true);
      // localStorage.setItem('tourTime', true);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        collapse: _unref(isCollapse),
        "active-text-color": "#F38558",
        class: "el-menu-vertical-demo",
        "collapse-transition": "",
        "default-active": activeIndex.value
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuList.value, item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.index
          }, [item.children ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: item.index,
            class: "my-menu-group"
          }, {
            title: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "my-menu-group"
            }, {
              default: _withCtx(() => [_createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)]),
              _: 2
            }, 1024), _createElementVNode("span", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('menu.' + item.title)), 1), item.hasNewFeature ? (_openBlock(), _createElementBlock("i", _hoisted_3)) : _createCommentVNode("", true)])]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, group => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: group.groupTitle || group.index
              }, [group.groupTitle ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, groupItem => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  key: groupItem.index,
                  index: groupItem.index,
                  onClick: $event => handleClickProFeature(groupItem.path, item.hasNewFeature)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(groupItem.title)), 1)]),
                  _: 2
                }, 1032, ["index", "onClick"]);
              }), 128))])) : (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 1,
                index: group.index
              }, {
                title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(group.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, child => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: child.index,
                    index: child.index,
                    onClick: $event => handleClickProFeature(child.path, item.hasNewFeature)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.' + child.title)), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"]))], 64);
            }), 128))]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            disabled: item.disabled,
            index: item.index,
            style: {
              "min-width": "60px"
            },
            onClick: $event => handleClickProFeature(item.path, item.hasNewFeature)
          }, {
            title: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.' + item.title)), 1), item.hasNewFeature ? (_openBlock(), _createElementBlock("i", _hoisted_6)) : _createCommentVNode("", true)])]),
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["disabled", "index", "onClick"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["collapse", "default-active"]);
    };
  }
};